import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { AppsPermissions } from '../../shared/enum/AppRoles'
@Injectable({
    providedIn: 'root'
  })
export class AppsService {
    
    public userRoleIds: any;
    APIURL = environment.baseUrl;
    constructor(private http: HttpClient) { }

   



    getEntities(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Entities/GetClientEntiites`)
    }

    getOpco(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Entities/GetEntiites`)
    }

    getusersByEntityId(entityDetails: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/ManageEntity/` + entityDetails)
    }

    addUsersInEntity(entities: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/ManageEntity`, entities)
    }

    getPeople(name: string, email: string, job: string, pageIndex: Number, pageSize: Number): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/User?SearchName=` + name + `&SearchEmail=` + email + `&SearchJob=` + job + `&isAsc=true&columnName=id&pageNo=` + pageIndex + `&recordCount=` + pageSize)
    }

    getSFDCdist(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}sfdc-sync/getSFDCDistributor`)
    }

    getTaskActivities(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Activitys/getActivitys`)
    }

    getTaskOptions(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskOption/getTaskOptions`)
    }

    getTaskTypes(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskType/getAllTaskTypes`)
    }

    getTaskMaster(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Jobs/TaskMaster`)
    }

    getTaskEvents(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Jobs/getEvents`)
    }

    getTaskTechnogies(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Technologys/Technologys, {observe: 'response'}`)
    }

    getTaskFlow(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/getFlows`)
    }

    getTaskActivitiesById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Activitys/` + id)
    }

    getTaskOptionById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskOption/` + id)
    }

    getTaskTypeById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskType/` + id)
    }

    getTaskMasterById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskMaster/` + id)
    }

    getTaskEventById(id: string): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskEvent/` + id)
    }

    getTaskTechnogiesById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Technologys/` + id)
    }

    getTaskFlowById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/getFlow/` + id)
    }

    getTaskTypeDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskType/getTaskTypesDLL`)
    }

    getTaskActivityDataSource(taskTypeId: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Activitys/getActivityDll/` + taskTypeId)
    }

    getTaskOptionDataSource(taskTypeId: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskOption/getTaskOptionsDLL/` + taskTypeId)
    }

    getTaskFlowDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskFlow/getFlowsDLL`)
    }

    getGroups(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Groups/getAllGroups`)
    }

    getEntitiesDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/Entities/GetEntiitesDll`)
    }

    getUsersDataSource(entitiyId: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/User/GetUsersDll?entityId=` + entitiyId)
    }

    addGroup(group: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/Groups/AddGroup?group=`, group)
    }

    getTaskMasterDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/TaskMaster`)
    }

    addTaskType(addTaskTypeRequest: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/TaskType/addTaskType`, addTaskTypeRequest)
    }

    addTaskActivity(addTaskActivity: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/Activitys`, addTaskActivity)
    }

    addTaskEvent(addTaskEvent: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/TaskEvent/postEvent`, addTaskEvent)
    }

    addTaskFlow(addRequest: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/TaskFlow`, addRequest)
    }

    addTaskTechnology(addRequest: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/technologys`, addRequest)
    }

    addTaskOption(addTaskOption: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/taskOption`, addTaskOption)
    }

    addTaskMaster(addTaskMaster: any): any {
        return this.http.post(`${this.APIURL}pqi-jobs/taskMaster/postMaster`, addTaskMaster)
    }

    updateTaskActivity(taskActivityId: any, taskActivityDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/Activitys/` + taskActivityId, taskActivityDetails)
    }

    updateTaskEvent(taskEventId: any, taskEventDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/TaskEvent/` + taskEventId, taskEventDetails)
    }

    updateTaskFlow(taskFlowId: any, taskFlowDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/TaskFlow/` + taskFlowId, taskFlowDetails)
    }

    updateTaskMaster(taskMasterId: any, taskMasterDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/TaskMaster/` + taskMasterId, taskMasterDetails)
    }

    updateTaskOption(taskOptionId: any, taskOptionDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/TaskOption/` + taskOptionId, taskOptionDetails)
    }

    updateTaskTechnology(taskTechnologyId: any, taskTechnologyDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/Technologys/` + taskTechnologyId, taskTechnologyDetails)
    }

    updateTaskType(taskTypeId: any, taskTypeDetails: any): any {
        return this.http.put(`${this.APIURL}pqi-jobs/TaskType/` + taskTypeId, taskTypeDetails)
    }

    deleteRecord(functionName: any, id: any) {
        switch (functionName) {
            case 'taskActivity':
                return this.http.delete(`${this.APIURL}pqi-jobs/Activitys/` + id)
                break;
            case 'taskEvent':
                return this.http.delete(`${this.APIURL}pqi-jobs/TaskEvent/` + id)
                break;
            case 'taskFlow':
                return this.http.delete(`${this.APIURL}pqi-jobs/TaskFlow/` + id)
                break;
            case 'taskMaster':
                return this.http.delete(`${this.APIURL}pqi-jobs/TaskMaster/` + id)
                break;
            case 'taskOption':
                return this.http.delete(`${this.APIURL}pqi-jobs/TaskOption/` + id)
                break;
            case 'taskTechnology':
                return this.http.delete(`${this.APIURL}pqi-jobs/Technologys/` + id)
                break;
            case 'taskType':
                return this.http.delete(`${this.APIURL}pqi-jobs/TaskType/` + id)
            case 'manageEntity':
                return this.http.delete(`${this.APIURL}pqi-jobs/ManageEntity`, {
                   
                    body: id
                });
                break;
            case 'emailTemplate':
                let emailDeleteURL = this.http.delete(`${this.APIURL}pqi-jobs/EmailTemplate/Email/DelteTemplate?Id=` + id)
                return emailDeleteURL
                break;
            case 'application':
                return this.http.delete(`${this.APIURL}AuthApps/` + id)
                break;
            case 'appPermission':
                return this.http.delete(`${this.APIURL}AuthAppsPermissions/` + id)
                break;                
            case 'role':
                return this.http.delete(`${this.APIURL}AuthRoles/` + id)
                break;
            case 'appRoles':
                return this.http.delete(`${this.APIURL}AuthAppsPermissions/` + id)
                break;
            case 'rolesAndPermission':
                return this.http.delete(`${this.APIURL}AuthRolesAndPermissions/` + id)
                break;
            case 'userProfile':
                return this.http.delete(`${this.APIURL}AuthUserProfile/` + id)
                break;
            case 'user':
                return this.http.delete(`${this.APIURL}User/` + id)
                break;
        }
    }
    //  getPlatforms(): Observable<any> {
    //     return this.http.get<any>(`${this.APIURL}Platform")
    // }

    //  getJobs(): Observable<any> {
    //     return this.http.get<any>(`${this.APIURL}TaskMaster")
    // }

    getSurveySchedulesData() {
        return this.http.get(`${this.APIURL}pqi-jobs/Jobs/getAllSchedules`)
    }

    getJobData(guid: any) {
        return this.http.get(`${this.APIURL}pqi-jobs/Jobs/getResponsesBySchedulerId/` + guid)
    }

    getMonthlyWiseReports() {
        return this.http.get(`${this.APIURL}pqi-jobs/Jobs/MonthlyWiseResponse`);
    }

    getEmailTemlates() {
        return this.http.get(`${this.APIURL}pqi-jobs/EmailTemplate/getEmailTemplate`);
    }

    updateEmailTemplate(templateId : number, templateDetails: any): any {
        debugger  
        templateDetails.id=templateId;               
        return this.http.put(`${this.APIURL}pqi-jobs/EmailTemplate/Email/updateTemplate?`, templateDetails)
    }

    addEmailTemplate(addtemplateDetails: any): any { 
        debugger       
        return this.http.post(`${this.APIURL}pqi-jobs/EmailTemplate/Email/postTemplate`, addtemplateDetails)
    }

    getEmailTemplateById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/EmailTemplate/` + id)
    }

    // editEmailTemplate(entities: any): any {

    //     return this.http.post(`${this.APIURL}ManageEntity`, entities)
    // }

    resetForm(e: MouseEvent, formGroup: FormGroup) {
        e.preventDefault();
        formGroup.reset();
        for (const key in formGroup.controls) {
            if (formGroup.controls.hasOwnProperty(key)) {
                formGroup.controls[key].markAsPristine();
                formGroup.controls[key].updateValueAndValidity();
            }
        }
    }

    getUserProfile(): Observable<any> {
        // return this.http.get<any>(`${this.APIURL}UserProfile`);
        return this.http.get<any>(`${this.APIURL}AuthUserProfile/getUser`);
    }

    getApps(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAllApps`)
    }
    getRoles(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAllRoles`)
    }
    getAppPermissions(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAllAppsPermissions`)
    }
    getRolesAndPermissions(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAllRolesAndAppsPermissions`)
    }

    getAppById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthApps?Id=` + id)
    }

    getAppPermissionsById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthAppsPermissions?Id=` + id)
    }

    getRoleById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthRoles?Id=` + id)
    }

    getRolesAndPermissionsById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthRolesAndPermissions?Id=` + id)
    }

    getUserProfileById(id: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthUserProfile?Id=` + id)
    }

    getApplicationsDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAppsDLL`)
    }

    getRolesDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getRolesDLL`)
    }

    getPermissionsDataSource(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}getAppsPermissionsDLL`)
    }

    addApp(addApp: any): any {
        return this.http.post(`${this.APIURL}addApp`, addApp)
    }

    addAppPermission(addAppPermission: any): any {
        return this.http.post(`${this.APIURL}addAppPermission`, addAppPermission)
    }

    addRole(addRole: any): any {
        return this.http.post(`${this.APIURL}addRole`, addRole)
    }

    addRolesAndPermissions(addRole: any): any {
        return this.http.post(`${this.APIURL}addRolesAndPermission`, addRole)
    }

    addUserProfile(userProfile: any): any {
        return this.http.post(`${this.APIURL}addUserProfile`, userProfile)
    }

    updateApp(appId: any, appDetails: any): any {
        return this.http.put(`${this.APIURL}AuthApps/` + appId, appDetails)
    }

    updateAppPermission(permissionId: any, appDetails: any): any {
        
        return this.http.put(`${this.APIURL}AuthAppsPermissions/` + permissionId, appDetails)
    }

    updateRole(appId: any, roleDetails: any): any {
       
        return this.http.put(`${this.APIURL}AuthRoles/` + appId, roleDetails)
    }

    updateRolesAndPermissions(roleAndPermissionId: any, roleDetails: any): any {
        
        return this.http.put(`${this.APIURL}AuthRolesAndPermissions/` + roleAndPermissionId, roleDetails)
    }

    updateUserProfile(userProfileId: any, userProfile: any): any {
       
        return this.http.put(`${this.APIURL}AuthUserProfile/` + userProfileId, userProfile)
    }

    getUsersDDL(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}pqi-jobs/User/GetDropdownUsers`)
    }

    getUserRolePermissions(userId: any, permissionId: any): Observable<any> {
        return this.http.get<any>(`${this.APIURL}AuthUserProfile/getUserPermissionDetails?userId=` + userId, + '&permissionId='+permissionId)
    }
    getSFDCCustomFeed(profileNumber): Observable<any> {
        return this.http.get<any>(`${this.APIURL}sfdc-sync/getSFDCCustomDataByProfile?profileNumber=${profileNumber}`)
    }
    getVideojetOffices(): Observable<any> {
        return this.http.get<any>(`${this.APIURL}public-web/getVideojetOffices`)
    }
   
    sendEmailHelp(mailContent: string, enquiryType: string) {
        const requestBody = {
            "mailContent": mailContent,
            "enquiryType": enquiryType
          };
        return this.http.post(`${this.APIURL}common-utility/Mailer/sendSupportEmail`, requestBody);
      }
      
      
    authenticateUser(ssoToken: any) {
        // debugger
        // let httpOptions = {
        //     headers: new HttpHeaders(
        //     {   
        //         'Content-Type': 'application/json',
        //         'Authorization': ssoToken 
        //     },
        //     )
        // };
        //return this.http.get<any>(`${this.APIURL}Auth/Authenticate`, httpOptions)
        return this.http.get<any>(`${this.APIURL}Auth/Authenticate`)

      }

      addUser(user: any): any {
        
        return this.http.post(`${this.APIURL}addUser`, user)
    }

    validatePermissionWithRole(moduleId: any): any {
        if (this.userRoleIds == AppsPermissions.SuperAdmin || this.userRoleIds == AppsPermissions.Admin) {
            return { insert: true, update: true, delete: true };
        } else {
           
            return JSON.parse(localStorage.getItem('authRoles'));
            // return { insert: true, update: true, delete: false };
        }
    }

    validatePermission(): any {
        if (this.userRoleIds == AppsPermissions.SuperAdmin || this.userRoleIds == AppsPermissions.Admin) {
            return { insert: true, update: true, delete: true };
        } else {
            
            return JSON.parse(localStorage.getItem('authRoles'));
            // return { insert: true, update: true, delete: false };
        }
    }
}